<template>
  <v-app>
    <v-container fluid >
      <template v-if="$insertAccess($route.path)">
        <v-form @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                    ><span>{{
                      isEntryMode
                        ? "CS Quotation Evalution Configration Setup"
                        : "Approval Setup Update"
                    }}</span></v-expansion-panel-title
                  >
                  <v-expansion-panel-text>
                    <v-row class="py-2 no-gutters align-center">
                      <v-col lg="3" md="4" cols="12">
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="name.value.value"
                          :error-messages="name.value.errorMessage"
                        >
                          <template #label>
                           Configration Name
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col lg="3" md="4" cols="12">
                        <v-date-input
                          input-format="dd/mm/yyyy"
                          label="Effective From Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="effective_from_date.value.value"
                          :error-messages="
                            effective_from_date.errorMessage.value
                          "
                          autocomplete="off"
                          clearable
                        ></v-date-input>
                      </v-col>

                      <v-col lg="3" md="4" cols="12">
                        <v-date-input
                          input-format="dd/mm/yyyy"
                          label="Effective To Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="effective_to_date.value.value"
                          :error-messages="effective_to_date.errorMessage.value"
                          autocomplete="off"
                          clearable
                        ></v-date-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-table
                          density="compact"
                          :loading="loading"
                          fixed-header
                          class="table-dotted-border-bottom"
                          style="min-height: 40vh"
                        >
                          <thead>

                            <tr >
                              <th style="width:1%">SL</th>
                              <th style="width: 20%">Field Name</th>
                              <th style="width: 10%">Weight Percent (%)</th>
                              <th style="width: 5%">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(detail, index) in configs" :key="index">
                              <td class="text-center">{{ index + 1 }}</td>
                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  class="pt-5"
                                  v-model="detail.field_name"
                                  :error-messages="
                                    getDetailError(index, 'field_name')
                                  "
                                >
                                  <template #label>
                                    Field Name
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>
                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  type="number"
                                  class="pt-5"
                                  v-model="detail.weight_percent"
                                  :error-messages="
                                    getDetailError(index, 'weight_percent')
                                  "
                                >
                                  <template #label>
                                    Weight Percent (%)
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>
                              <td class="py-1">
                                <v-btn
                                  @click="removeDetailRow(index)"
                                  variant="tonal"
                                  color="primary"
                                  v-if="index !== configs.length - 1"
                                >
                                  <v-icon
                                    color="red"
                                    icon="mdi-minus"
                                    size="medium"
                                  ></v-icon>
                                </v-btn>

                                <v-btn
                                  @click="addDetailRow"
                                  variant="tonal"
                                  color="primary"
                                  v-else
                                >
                                  <v-icon
                                    color="info"
                                    icon="mdi-plus"
                                    size="medium"
                                  ></v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-row class="pt-2">
                        <v-col cols="8">
                          <v-textarea
                            label="Remarks"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            autocomplete="off"
                            rows="3"
                            clearable
                          ></v-textarea>
                        </v-col>
                        <v-col cols="2">
                          <v-layout class="justify-end">
                            <v-btn
                              class="bg-grey-darken-1 me-2"
                              variant="flat"
                              @click="submitForm(0)"
                              type="button"
                              >DRAFT</v-btn
                            >
                            <v-btn
                              class="bg-brand w-15 ms-2"
                              variant="flat"
                              type="button"
                               @click="submitForm(1)"
                            >
                              {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import { useField, useForm } from "vee-validate";
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    isEntryMode: true,
    data: {},
    remarks: "",
  }),
  watch: {},
  created() {},
  computed: {},
  methods: {
    closeDialog() {
      this.dialog = false;
      this.data = {};
    },
    resetForm() {
      this.data = {};
    },
  },

  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({}),
    });

    const name = useField("name");
    const effective_from_date = useField("effective_from_date");
    const effective_to_date = useField("effective_to_date");

    const remarks = useField("remarks");

    const detailErrors = reactive({});
    const errorMessages = ref("");

    const currentStatus = ref(0);
    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const pur_cs_evaluation_configuration_master_id = useField(
      "pur_cs_evaluation_configuration_master_id"
    );

    const configs = ref([
      {
        field_name: "",
        weight_percent: "",
      },
    ]);

    const addDetailRow = () => {
      configs.value.push({
        field_name: "",
        weight_percent: "",
      });
    };

    const removeDetailRow = (index) => {
      if (configs.value.length > 1) {
        configs.value.splice(index, 1);
        delete detailErrors[index];
        const newErrors = {};
        Object.keys(detailErrors).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) {
            newErrors[idx - 1] = detailErrors[key];
          } else if (idx < index) {
            newErrors[idx] = detailErrors[key];
          }
        });
        Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
        Object.assign(detailErrors, newErrors);
      }
    };

    const loading = ref("");
    const isEntryMode = ref(true);

    const store = useStore();
    const router = useRouter();
    const validateDetailField = (index, field, value) => {
      if (!detailErrors[index]) {
        detailErrors[index] = {};
      }

      detailErrors[index][field] = "";

      switch (field) {
        case "field_name":
          if (!value || String(value).trim().length < 1) {
            detailErrors[index][field] = "Field Name is required";
          }
          break;

        case "weight_percent":
          if (
            value === null ||
            value === undefined ||
            String(value).trim().length < 1
          ) {
            detailErrors[index][field] = "Weight Percent is required";
          } else {
            const num = Number(value);
            if (Number.isNaN(num) || num <= 0 || num > 100) {
              detailErrors[index][field] =
                "Weight Percent must be a number between 0.01 and 100";
            }
          }
          break;
      }
    };

    const getDetailError = (index, field) => {
      return detailErrors[index] && detailErrors[index][field]
        ? [detailErrors[index][field]]
        : [];
    };

    const validateAllDetails = () => {
      let isValid = true;
      configs.value.forEach((detail, index) => {
        validateDetailField(index, "field_name", detail.field_name);
        validateDetailField(index, "weight_percent", detail.weight_percent);

        if (detailErrors[index]) {
          Object.values(detailErrors[index]).forEach((error) => {
            if (error) isValid = false;
          });
        }
      });

      return isValid;
    };
    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;

      values.configs = configs.value.map((detail) => ({
        field_name: detail.field_name,
        weight_percent: detail.weight_percent,
      }));

      store
        .dispatch("saveUpdateEvaluationCriteria", values)
        .then((response) => {
          resetForm();
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "evaluation-list" });
          }, 2000);
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });
    onMounted(() => {
      const id = router.currentRoute.value.query.id;
      if (id) {
        store.commit("SET_LOADING", { color: "primary" });
        store
          .dispatch("getEvaluationCriteriaById", id)
          .then((matrix) => {
            isEntryMode.value = false;
            pur_cs_evaluation_configuration_master_id.value.value = matrix.id;
            name.value.value = matrix.name;
            effective_from_date.value.value = matrix.effective_from_date;
            effective_to_date.value.value = matrix.effective_to_date;
            remarks.value.value = matrix.remarks;
            if (matrix.evaluation_criteria.length > 0) {
              configs.value = [];
            }

            (matrix.evaluation_criteria || []).forEach((item) => {
              configs.value.push({
                field_name: item.field_name,
                weight_percent: item.weight_percent,
              });
            });
            store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            store.commit("UNSET_LOADING");
            console.error("Failed to fetch receive:", error);
          });
      }
    });
    return {
      submitForm,
      submit,
      name,
      effective_from_date,
      effective_to_date,
      configs,
      addDetailRow,
      removeDetailRow,
      remarks,
      errorMessages,
      isEntryMode,
      resetForm,
      pur_cs_evaluation_configuration_master_id,
      loading,
      detailErrors,
      validateDetailField,
      getDetailError,
      validateAllDetails,
    };
  },
};
</script>
